import { RunnableLambda } from '@langchain/core/runnables';
import { OpenAI } from 'openai';
import { Thread } from 'openai/resources/beta/threads/threads';

const ASSISTANT_ID = 'asst_nvikNAkZ27GhsjadCUylBfE3';

export const assistant = (content: string, openAi: OpenAI, thread: Thread) => {
  return new RunnableLambda({
    func: async () => {
      await openAi.beta.threads.messages.create(thread.id, {
        role: 'user',
        content,
      });

      const run = await openAi.beta.threads.runs.create(thread.id, {
        assistant_id: ASSISTANT_ID,
      });

      await pollRunUntilComplete(thread.id, run.id, openAi);

      const messages = await openAi.beta.threads.messages.list(thread.id);

      const assistantReply = messages.data
        .reverse()
        .find((msg) => msg.role === 'assistant');

      const textBlock = assistantReply?.content?.find(
        (block) => block.type === 'text',
      ) as { type: 'text'; text: { value: string } } | undefined;

      return textBlock?.text?.value ?? '(No text response)';
    },
  });
};

const pollRunUntilComplete = async (
  threadId: string,
  runId: string,
  openAi: OpenAI,
) => {
  while (true) {
    const runStatus = await openAi.beta.threads.runs.retrieve(threadId, runId);
    if (runStatus.status === 'completed') {
      return runStatus;
    } else if (['failed', 'cancelled', 'expired'].includes(runStatus.status)) {
      throw new Error(`Run ${runStatus.status}`);
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }
};
